import { APIReferenceAttributes } from '@ardoq/api-types';
import type { EnhancedScopeData } from '@ardoq/data-model';

export const getModelIdFromReference = (
  reference: APIReferenceAttributes,
  enhancedScopeData: Pick<EnhancedScopeData, 'workspacesById'>
) =>
  // Prefer the reference's own model — it's set on app scope data and is
  // VIRTUAL_MODEL_ID for virtual (collapsed-path) references. Some shaped scope
  // data (e.g. ardoq-discover communities) omits it on references, so fall back
  // to the rootWorkspace's component model.
  reference.model ??
  enhancedScopeData.workspacesById[reference.rootWorkspace]?.componentModel;

export const getModelIfFromSourceComponent = (
  // Sometimes the branch-off doesn't have workspace data. Use component for model id instead
  reference: APIReferenceAttributes,
  enhancedScopeData: EnhancedScopeData
) => enhancedScopeData.componentsById[reference.source].model;
